/**
 * Public read of the sign-up gating flag — needed by unauthenticated
 * pages (LoginPage, SignUpPage) to render the right CTAs.
 *
 * Backed by /api/v1/public/signup-mode (no auth required). The value
 * isn't sensitive — anyone can discover it by trying to sign up and
 * getting the INVITE_REQUIRED rejection — so a public endpoint is the
 * cleanest way to keep the SPA's UI honest.
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/client';

interface SignupModeResponse {
  inviteOnly: boolean;
}

export function useSignupMode() {
  return useQuery<{ inviteOnly: boolean }>({
    queryKey: ['f', 'public', 'signup-mode'],
    queryFn: () =>
      api.get<SignupModeResponse>('/public/signup-mode').then((r) => ({
        inviteOnly: r.inviteOnly,
      })),
    // Cache for a few minutes — admin toggling this is rare and the
    // cost of being slightly stale is "user sees the wrong CTA for a
    // few minutes after a toggle," which is fine.
    staleTime: 5 * 60 * 1000,
  });
}
